<template>
  <div class="prompt">
    <div class="prompt-label">{{ modalObj.promptLabel }}</div>
      <div class="prompt-description">{{ modalObj.promptDescription }}</div>
    <div class="button-holder">
      <div class="cancel-button" v-show="modalObj.buttonCancel !== undefined" @click.stop="modalObj.buttonCancel">Cancel</div>
      <div class="button" @click.stop="modalObj.buttonAFunc">{{ modalObj.buttonALabel }}</div>
    </div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';

export default {
  name: 'ModalWarning',
  props: [
    'obj'
  ],
  computed: {
    modalObj () {
      return useModalStore().modalObj;
    }
  }
};
</script>

<style scoped>
.prompt {
  width: 350px;
  height: 350px;
  padding: 10px 20px;
  background-color: white;
}
.button-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 5px;
}
.button {
  margin: 5px;
  padding: 10px 25px;
  color: white;
  font-weight: 700;
  font-size: .9em;
  text-transform: uppercase;
  cursor: pointer;
  background-color: var(--nelson-green);
}
.prompt-label {
  font-weight: bold;
  padding-top:10px;
  padding-bottom:10px;
}
.prompt-description {
  padding-bottom: 10px;
  font-size: .95em;
}
.cancel-button {
  font-size: 80%;
  padding-right:30px;
  cursor: pointer;
}
</style>